module.exports = ($node) => {
  $node
    .on("touchmove", function (event) {
      // console.log(event);
      const $t = $(this);
      const isMouseDown = $t.attr("data-mouse-down") === "true";
      if (isMouseDown) {
        const mouseDownX = $t.attr("data-mouse-down-x") * 1;
        // const mouseDownY = $t.attr('data-mouse-down-y') * 1;
        if (mouseDownX) {
          if (mouseDownX - event.originalEvent.touches[0].pageX > 20) {
            $t.trigger("mouseLeftMove")
              .attr(
                "data-mouse-down-x",
                `${event.originalEvent.touches[0].pageX}`
              )
              .attr(
                "data-mouse-down-y",
                `${event.originalEvent.touches[0].pageY}`
              );
          } else if (event.originalEvent.touches[0].pageX - mouseDownX > 20) {
            $t.trigger("mouseRightMove")
              .attr(
                "data-mouse-down-x",
                `${event.originalEvent.touches[0].pageX}`
              )
              .attr(
                "data-mouse-down-y",
                `${event.originalEvent.touches[0].pageY}`
              );
          }
        }
      }
    })
    .on("touchstart", function (event) {
      $(this)
        .attr("data-mouse-down", "true")
        .attr("data-mouse-down-x", `${event.originalEvent.touches[0].pageX}`)
        .attr("data-mouse-down-y", `${event.originalEvent.touches[0].pageY}`);
    })
    .on("touchend", function () {
      $(this)
        .attr("data-mouse-down", "false")
        .attr("data-mouse-down-x", "0")
        .attr("data-mouse-down-y", "0");
    });
};
